import { render, staticRenderFns } from "./BookerOrderDistribution.vue?vue&type=template&id=66abe024"
import script from "./BookerOrderDistribution.vue?vue&type=script&lang=js"
export * from "./BookerOrderDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports